import { observer } from "mobx-react-lite";

import { useSnippetOverrideStore } from "../../playground-store";

import { useSnippetDialog } from "./snippet-store";

import { ChooseEntityDialogControlled } from "@/components/ChooseEntityDialog";
import { Dialog } from "@/components/ui/dialog";
import { Entity, EntityType, getEntityNumericId } from "@/queries";

const SnippetDialog = () => {
  const dialog = useSnippetDialog()!;
  const snippetOverrideStore = useSnippetOverrideStore();

  const handleOpenChange = (open: boolean) => {
    if (!open) {
      dialog.closeDialog();
    }
  };

  return (
    <Dialog>
      <ChooseEntityDialogControlled
        type={EntityType.SNIPPET}
        open={dialog.isOpen}
        onOpenChange={handleOpenChange}
        currentFolderId={null}
        selectedEntity={dialog.configuration.template as Entity}
        onSelect={entity => {
          const oldTemplateName = dialog.configuration.template?.name;
          dialog.setConfiguration({
            ...dialog.configuration,
            template: {
              id: getEntityNumericId(entity.id),
              name: entity.name,
              version_number: entity.version_number ?? null,
              label: entity.label,
            },
          });
          if (oldTemplateName) {
            snippetOverrideStore?.removeSnippetOverride(`@@@${oldTemplateName}@@@`);
          }
        }}
        config={{
          selectLatest: false,
        }}
      />
    </Dialog>
  );
};

export default observer(SnippetDialog);
